import pic_2 from './images/pic_2.jpg';
import pic_3 from './images/pic_3.jpg';
import pic_4 from './images/pic_4.jpg';
import pic_5 from './images/pic_5.jpg';

const data_product = [
    {
        id:1,
        name: "canvas 1",
        category : "type 1",
        image: pic_2,
        new_price: "50.0",
        old_price: "80.6",
    },
    {
        id:2,
        name: "canvas 2",
        category : "type 2",
        image: pic_3,
        new_price: "60.0",
        old_price: "90.6",
    },
    {
        id:3,
        name: "canvas 3",
        category : "type 3",
         image: pic_4,
        new_price: "70.0",
        old_price: "100.6",
    },
    {
        id:4,
        name: "canvas 4",
        category : "type 4",
        image: pic_5,
        new_price: "80.0",
        old_price: "110.6",
    },
]

export default data_product;